import { render, staticRenderFns } from "./UserInformationList.vue?vue&type=template&id=8379574e&"
import script from "./UserInformationList.vue?vue&type=script&lang=js&"
export * from "./UserInformationList.vue?vue&type=script&lang=js&"
import style0 from "./UserInformationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports